import { shouldTrackEvents } from "./shouldTrackEvents";

export const gtagEvent = (eventName, data = {}) => {
  if (typeof window.gtag === 'function' && shouldTrackEvents()) {
    window.gtag('event', eventName, data);
  } else {
    console.warn('[GTAG] Not initialized');
  }
};
